import { View } from "tamagui";
import { Row } from "./layout";
import { Caption } from "./text";

/** A busy indicator; the optional label is what a screen reader announces. */
export function Spinner({ label }: { label?: string }): React.JSX.Element {
  return (
    <Row gap="2" minHeight={24} role="status">
      <View
        className="ui-spin"
        width={20}
        height={20}
        borderRadius="pill"
        borderWidth={2}
        borderColor="lineStrong"
        borderTopColor="accent"
        aria-hidden
      />
      {label !== undefined && <Caption weight="medium">{label}</Caption>}
    </Row>
  );
}
